import {
  INVISIBLE_PROPS,
  type ToggleButtonActionProps,
  type ToggleButtonMapProps,
  VisibleToggleButton
} from "@client/controls/Button/ToggleButton/component";
import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState, ScreenType } from "@client/types";
import { headerVisibilitySelector } from "@client/widgets/Header/selectors";
import { toggleSidePanel } from "@client/widgets/SidePanel/actions";
import classnames from "classnames";
import { isSidePanelStaticSelector, visibilitySelector } from "../selectors";

export interface SidePanelToggleContainerProps {
  isOutsideHeader: boolean;
}

export const mapStateToProps = (
  state: AppState,
  props: SidePanelToggleContainerProps
): ToggleButtonMapProps & WithIsVisibleHOCProps => {
  const visibility = visibilitySelector(state);
  if (!visibility.isVisible) return INVISIBLE_PROPS;

  const headerVisibility = headerVisibilitySelector(state);
  if (headerVisibility.isVisible && props.isOutsideHeader) return INVISIBLE_PROPS;

  const {
    viewport,
    widgets: { sidePanel }
  } = state;
  const isStatic = isSidePanelStaticSelector(state);
  if (isStatic && viewport.screen === ScreenType.Desktop) return INVISIBLE_PROPS;

  return {
    className: classnames("wsc_side_panel_toggle", { standalone: props.isOutsideHeader }),
    isToggled: sidePanel.isToggled,
    isVisible: true
  };
};

const mapDispatchToProps = (dispatch): ToggleButtonActionProps => ({
  onClick: () => dispatch(toggleSidePanel())
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(VisibleToggleButton);
